import React, { useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import UseQsButton from "./utils/UseQsButton";

const productionData = [
  {
    label: "Liten, maks. 5 GV per uke",
    F: 30,
    Vp: 20,
  },
  {
    label: "Middels, 6 - 10 GV per uke",
    F: 35,
    Vp: 15,
  },
  {
    label: "Stor, 11-40 GV per uke",
    F: 40,
    Vp: 10,
  },
];

function GVCalculationModal({ open, onClose, setMeatProduction }) {
  const [GVperWeek, setGVperWeek] = useState("");
  const [workDays, setWorkDays] = useState("");
  const [Mp, setMp] = useState(100); // default value

  const handleCalculate = () => {
    const productionPerDay = (GVperWeek * Mp) / workDays;
    setMeatProduction(productionPerDay);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxHeight: "90vh",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
        }}
      >
        {/* The GV calculation fields here */}

        <Typography variant="h6" gutterBottom>
          Kalkuler kjøpttproduksjon
        </Typography>

        <Grid container justifyContent="center">
          <Box sx={{ maxWidth: "300px" }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontStyle: "italic",
                color: "text.secondary",
                textAlign: "center",
                mt: 0,
              }}
            >
              Bruk denne kalkulatoren hvis du ikke har informasjon om mengde
              (kg) kjøtt som produseres hver dag.
            </Typography>
          </Box>
        </Grid>
        <TextField
          label="Antall GV per uke"
          type="number"
          value={GVperWeek}
          onChange={(e) => setGVperWeek(e.target.value)}
        />
        <TextField
          label="Arbeidsdager per uke"
          type="number"
          value={workDays}
          onChange={(e) => setWorkDays(e.target.value)}
        />
        <TextField
          label="Mp (kg/GV)"
          value={Mp}
          type="number"
          onChange={(e) => setMp(e.target.value)}
        />
        <Button
          onClick={handleCalculate}
          variant="contained"
          color="primary"
          disabled={!GVperWeek || !workDays || !Mp}
        >
          Kalkuler
        </Button>
      </Box>
    </Modal>
  );
}

function MeatProductionCalculator({handleSetQs}) {
  const [meatProduction, setMeatProduction] = useState("");
  const [productionType, setProductionType] = useState("");
  const [T, setT] = useState("");
  const [showGVModal, setShowGVModal] = useState(false);

  const selectedProduction = productionData.find(
    (item) => item.label === productionType
  );

  const calculateQs = () => {
    if (meatProduction && selectedProduction && T) {
      const productionPerDay = meatProduction;
      const V = productionPerDay * selectedProduction.Vp;
      const Qs = V * selectedProduction.F / (T * 3600);
      return Qs;
    }
    return 0;
  };

  return (
    <>
      <UseQsButton Qs={calculateQs()} handleSetQs={handleSetQs}/>

      <Grid container spacing={3}>
        <Grid item xs={12} mt={1}>
          <FormControl fullWidth>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                label="Kjøttproduksjon per dag (kg)"
                value={meatProduction}
                multiline
                sx={{ flexGrow: 1, mr: 0 }}
                onChange={(e) => setMeatProduction(e.target.value)}
              />
              {meatProduction === "" && (
                <Button
                  onClick={() => setShowGVModal(true)}
                  sx={{ flexShrink: 0, mx:2 }}
                >
                  Kalkuler kjøttproduksjon?
                </Button>
              )}
              <GVCalculationModal
                open={showGVModal}
                onClose={() => setShowGVModal(false)}
                setMeatProduction={setMeatProduction}
              />
            </Box>
          </FormControl>
        </Grid>
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Produksjonsmengde</InputLabel>
              <Select
                value={productionType}
                onChange={(e) => setProductionType(e.target.value)}
                label="Produksjonmengde"
              >
                {productionData.map((item) => (
                  <MenuItem key={item.label} value={item.label}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="arbeidstimer per dag (T)"
              value={T}
              onChange={(e) => setT(e.target.value)}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Vannføringsfaktor (F)</TableCell>
                  <TableCell>Forbrukt vannmengde (V)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{selectedProduction?.F || "-"}</TableCell>
                  <TableCell>
                    {meatProduction && selectedProduction
                      ? meatProduction * selectedProduction.Vp
                      : "-"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
}

export default MeatProductionCalculator;
